<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-subtitle>{{ $t("* Required fields") }}</v-card-subtitle>
      <v-card-text>
        <validation-observer ref="form">
          <v-container>
            <validation-provider
              v-slot="{ errors }"
              name="reseller_entity_id"
              rules="required"
            >
              <v-select
                data-cy="select-input-agence"
                :label="`${$t('Entity')} *`"
                :items="entities"
                item-text="name"
                item-value="id"
                v-model="editedItem.reseller_entity_id"
                :error-messages="errors"
              ></v-select>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="serial_number"
              rules="required|max:45"
            >
              <v-text-field
                data-cy="text-field-serial-number"
                :disabled="!newItem"
                name="serial_number"
                v-model="editedItem.serial_number"
                :label="`${$t('Serial number')} *`"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="model"
              rules="max:255"
            >
              <v-text-field
                data-cy="text-field-model"
                name="model"
                v-model="editedItem.model"
                :label="$t('Model')"
                :error-messages="errors"
              ></v-text-field>
            </validation-provider>
            <validation-provider
              v-slot="{ errors }"
              name="description"
              rules="max:255"
            >
              <v-textarea
                data-cy="text-area-description"
                name="description"
                v-model="editedItem.description"
                :label="$t('Description')"
                counter="255"
                rows="3"
                :error-messages="errors"
              ></v-textarea>
            </validation-provider>
            <validation-provider v-slot="{ errors }" name="client_id">
              <v-autocomplete
                data-cy="select-input-client"
                :label="$t('Customer')"
                :items="clientsFilteredByEntity"
                item-text="name"
                item-value="id"
                v-model="editedItem.client_id"
                :error-messages="errors"
                clearable
              ></v-autocomplete>
            </validation-provider>
          </v-container>
        </validation-observer>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click.stop="$emit('close')">{{
          $t("Cancel")
        }}</v-btn>
        <v-btn
          color="primary"
          data-cy="button-save-device"
          :loading="loading"
          text
          @click.stop="save"
          >{{ $t("Save") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import snackbar from "@/mixins/snackbar";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "AddEditEntityDialog",
  props: ["value"],
  components: { ValidationObserver, ValidationProvider },
  mixins: [snackbar],
  data() {
    return {
      loading: false,
    };
  },
  watch: {
    dialog(value) {
      if (value && this.$refs.form) {
        this.$refs.form.reset();
      }
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    ...mapState({
      editedId: (state) => state.devices.editedId,
      entities: (state) => state.auth.user.reseller_entities,
      clients: (state) => state.clients.items,
    }),
    clientsFilteredByEntity() {
      if (!this.editedItem.reseller_entity_id) {
        return this.clients;
      }

      return this.clients.filter(
        (client) =>
          client.reseller_entity_id === this.editedItem.reseller_entity_id
      );
    },
    editedItem: {
      get() {
        return this.$store.state.devices.editedItem;
      },
      set(value) {
        this.$store.commit("devices/setEditedItem", value);
      },
    },
    newItem() {
      return this.editedId === -1;
    },
    formTitle() {
      return this.editedId === -1
        ? this.$t("New device")
        : this.$t("Modify device");
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((success) => {
        if (!success) {
          return;
        }
        this.loading = true;
        if (this.editedId === -1) {
          this.$store
            .dispatch("devices/saveEditedItem")
            .then((response) => {
              this.$emit("created", response.data);
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar(
                "success",
                this.$t("snackbar-message-device.added")
              );
            })
            .catch(this.responseError);
        } else {
          this.$store
            .dispatch("devices/updateEditedItem")
            .then(() => {
              this.$refs.form.reset();
              this.loading = false;
              this.dialog = false;
              this.snackbar(
                "success",
                this.$t("snackbar-message-device.updated")
              );
            })
            .catch(this.responseError);
        }
      });
    },
    responseError(error) {
      this.loading = false;
      if (error.response && error.response.status === 422) {
        let errors = error.response.data.errors;
        this.$refs.form.setErrors(errors);
      } else {
        this.snackbar("error", this.$t("snackbar-message-device.error"));
      }
    },
  },
};
</script>